import "./savingsAccountsOffersViewError.scss";
// vendors
import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';
const { FormattedText } = i18n;
// components
import { OKButton } from 'commonsComponents/OKButton';

const SavingsAccountsOffersViewError = ({ onButtonClick }) => {
    return (
        <section className="savings-accounts-offers-view-error-section">
            <header className="savings-accounts-offers-view-error-section__icon-container" />
            <section className="savings-accounts-offers-view-error-section__texts">
                <div>
                    <FormattedText value="accounts-accounts_noDataBannerErrorTitle" />
                </div>
                <div>
                    <FormattedText value="savingsAccounts-savingsAccounts_errorSectionSecondaryText" />
                </div>
            </section>
            <footer>
                <OKButton modifier="secondary" onClick={onButtonClick}>
                    <FormattedText value="common-retry" />
                </OKButton>
            </footer>
        </section>
    );
};

SavingsAccountsOffersViewError.propTypes = {
    onButtonClick: PropTypes.func.isRequired
};



export default SavingsAccountsOffersViewError;